import { PayloadAction, createSlice } from '@reduxjs/toolkit'

type InitialState = {
  isActive: boolean
  message: string
  requiresReauth: boolean
}

const DEFAULT_MAINTENANCE_MESSAGE =
  'Application is under maintenance. Please try again later.'

const initialState: InitialState = {
  isActive: false,
  message: DEFAULT_MAINTENANCE_MESSAGE,
  requiresReauth: false,
}

export const maintenanceSlice = createSlice({
  name: 'maintenance',
  initialState,
  reducers: {
    activateMaintenance: (
      state,
      action: PayloadAction<{ message?: string | null }>
    ) => {
      state.isActive = true
      state.requiresReauth = false
      state.message =
        action.payload.message?.trim() || DEFAULT_MAINTENANCE_MESSAGE
    },
    recoverFromMaintenance: (state) => {
      if (!state.isActive) return
      state.isActive = false
      state.requiresReauth = true
      state.message = DEFAULT_MAINTENANCE_MESSAGE
    },
    clearReauthRequirement: (state) => {
      state.requiresReauth = false
    },
  },
})

export const {
  activateMaintenance,
  recoverFromMaintenance,
  clearReauthRequirement,
} = maintenanceSlice.actions

export default maintenanceSlice.reducer
